






































































































import { defineComponent, computed, watch, ref, Ref } from "@vue/composition-api"
import i18n from "@/ts/plugins/i18n.js";
import store from '@/ts/store';
import Notifications from "@c/molecules/notification/Notifications.vue";
import useFetcher from '@/ts/functions/composition/useFetcher';
import { useMutations, useActions } from 'vuex-composition-helpers';

export default defineComponent({

  name : "Navigation",

  components: {
    Notifications
  },

  setup(props, {root}) {

    var { entity: user, loading } = useFetcher("auth/GET_USER_DATA");

    const { setLocale } = useMutations({setLocale: "app/setLocale"} as any);
    const { SEND_USER_EDITION } = useActions({SEND_USER_EDITION: "auth/SEND_USER_EDITION"} as any);

    const appTitle = "Lesiteco"
    const locales = ["fr", "en"]
    var selected_locale = ref(i18n.locale)

    const topNavItems = [
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("connection")),
          path: "/login",
          icon: ""
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("register")),
          path: "/register",
          icon: ""
        }
    ]

    var activeItems:Ref<Array<Object>> = computed(() => {
      if (user.value == undefined) {
        return topNavItems;
      } else {
        return accountItems.value;
      }
    })

    var accountItems:Ref<Array<Object>> = computed(() => {
      return [
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("my profil")),
          path: "/user/" + user.value.id,
          icon: "account_circle"
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("my places")),
          path: "/places/myplaces",
          icon: "home"
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("my network")),
          path: "/network",
          icon: "share"
        },
        {
          title: root.$options.filters!.capitalize(root.$i18n.t("settings")),
          path: "/settings",
          icon: "settings"
        }
      ];
    })

    const changeLocale = () => {

      var newUser = {...user.value}
      newUser.locale = selected_locale.value
      SEND_USER_EDITION(newUser).then(()=>{
        store.commit("app/setAlert", null);
        setLocale(selected_locale.value);
        root.$router.go(0);
      });
    }

    const search = () => {
      return [];
    }

    watch(() => computed, (newValue:any) => {
      //
    }, {deep:false});

    return{
      appTitle,
      locales,
      selected_locale,
      user,
      changeLocale,
      loading,
      activeItems
      
    }

  }
});
